module.exports = __webpack_public_path__ + "static/media/logo.f7e4992a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 182
// module chunks = 0